interface IconProps {
    width?: number;
    height?: number;
}

export default function UsersIcon({ width = 20, height = 20 }: IconProps) {
    return (
        <svg
            viewBox="0 0 256 256"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}>
            <title />
            <g>
                <rect fill="none" height="256" width="256" />
                <circle cx="88" cy="108" opacity="0.2" r="52" />
                <circle cx="88" cy="108" fill="none" r="52" stroke="currentColor" strokeMiterlimit="10" strokeWidth="16" />
                <path d="M155.4,57.9A54.5,54.5,0,0,1,169.5,56a52,52,0,0,1,0,104" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" />
                <path d="M16,197.4a88,88,0,0,1,144,0" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" />
                <path d="M169.5,160a87.9,87.9,0,0,1,72,37.4" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" />
            </g>
            <g id="frame">
                <rect fill="none" height="256" width="256" />
            </g>
        </svg>
    )
}